<div #magnifier id="magnifier-glass"
     [hidden]="!shouldDisplay()"
     [style.background-image]="'url(' + imageUrl + ')'"
     [style.background-size]="backgroundSize"
     [style.background-position]="backgroundPosition"
     [style.border-width.px]="magnifierBorderSize"
></div>
